export const PostageDefaultsModelModule = angular
    .module('app.services.model.models.postageDefaultsModel', [])
    .value('postageDefaultsModel', {
        revision: 'Number',
        tenant: 'String',
        materialPackageSize: {
            length: 'Number',
            width: 'Number',
            height: 'Number',
            name: 'String'
        },
        defaultId: 'String',
        hasReturnLabel: 'Boolean',
        labelType: 'String',
        handlingTime: 'Number'
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/model/models/postageDefaults.model.js